import React, { useState, useEffect } from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";
import {
  Box,
  Divider,
  Typography,
  Stack,
  Slide,
  Button,
  IconButton,
} from "@mui/material";

import { Images } from "./../../assets/common";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";

import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import TipContainer from "./../../components/TipContainer";
import ApiService from "./../../services/api-service";
import Loader from "./../../components/Loader";
import { useDispatch, useSelector } from "react-redux";
import { addSongAction } from "./../../action/songs";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import {
  fullName,
  formatedDate,
  isOwner,
  isOwnerId,
  convertHMS,
  copyToClipboard,
  generateDynamicLink,
  onShare,
  getErrorString,
  getUserDetail,
  putRecors,
} from "./../../constants/function";
import BuyBidInfo from "../BuyBidInfo";
import notifier from "../../components/Notifier";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import AddMusicToPlaylist from "../../components/AddMusicToPlaylist";
import ProfileMenu from "../../components/ProfileMenu";
import OutsideClickHandler from "react-outside-click-handler";
import IosShareIcon from "@mui/icons-material/IosShare";
import { useTranslation } from "react-i18next";
import HMSTag from "../../components/HMS/hms";
export default function SongDetails() {
  const { t } = useTranslation("common");
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const nftId = searchParams.get("nftId");
  const referralId = searchParams.get("referralId");
  const userData = getUserDetail();
  const songs = useSelector((state) => state.songs);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [musicDetail, setMusicDetail] = useState({});
  const [buyBid, setBuyBid] = useState(false);
  const { id } = useParams();
  const history = useHistory();
  const [openAlbumMenu, setAlbumMenu] = React.useState(false);
  const [showPlaylist, setShowPlaylist] = React.useState(false);
  const [selectedId, setSelectedAlbum] = React.useState();
  const [selectedIndex, setSelectedIndex] = React.useState(null);
  const [open, setOpen] = useState(false);
  const [isAlbum, setIsAlbum] = React.useState(false);
  const [index, setIndex] = React.useState(-1);
  const [owners, setOwners] = useState([]);
  const [nftDetail, setNftDetails] = useState({});
  const [option, setOption] = React.useState(false);

  const getMusicDetail = async (_id) => {
    try {
      setLoading(true);
      const response = await ApiService.MUSIC_DETAIL(_id);
      setMusicDetail({ ...response["result"] });
      if (window.location.href.includes("referralId="))
        putRecors({
          id: userData._id,
          referralLink: window.location.href,
          eventType: ["sharedInbound"],
          eventAsset: musicDetail?._id,
          eventValue: ["Music"],
          socialMedia: null,
          referralId: referralId,
        });
      else
        putRecors({
          id: userData._id,
          referralLink: window.location.href,
          eventType: ["view"],
          eventAsset: musicDetail?._id,
          eventValue: ["Music"],
          socialMedia: null,
        });
      setLoading(false);
    } catch (error) {
      setLoading(false);
      if (
        getErrorString(error) ===
        "This is an explicit content you need to be above 18 to view it"
      ) {
        notifier.error(getErrorString(error));
        history.push("/app/Home");
      }
    }
  };
  const getNftDetails = async (_id) => {
    try {
      setLoading(true);
      const response = await ApiService.NFT_BY_ID(_id);
      const detail = response["result"];
      if (response["result"] && !response["result"]["playlistDetails"])
        setOwners([...response["result"]]);
      if (response["result"])
        detail["nftDetails"] = {
          onAuction: response["result"][0]["onAuction"],
          onSale: response["result"][0]["onSale"],
          sellingPrice: response["result"][0]["sellingPrice"],
        };
      detail["nftId"] = _id;
      setNftDetails({ ...response["result"][0] });
      // detail({ ...detail, ...response["result"]["musicDetails"] });
      setMusicDetail({ ...detail, ...response["result"][0]["musicDetails"] });

      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };
  React.useEffect(() => checkForSell(), [owners]);
  const checkForSell = () => {
    for (let index = 0; index < owners.length; index++) {
      if (
        !isOwnerId(owners[index]["owner"]["_id"]) &&
        owners[index]["onSale"]
      ) {
        setIndex(index);
        return;
      }
    }
    setIndex(-1);
  };
  React.useEffect(() => {}, [index]);
  const getPlaylistNftDetails = async (_id) => {
    try {
      setLoading(true);
      const response = await ApiService.PLAYLIST_NFT_BY_ID(_id);
      const detail = response["result"];
      if (response["result"])
        detail["nftDetails"] = {
          onAuction: response["result"]["onAuction"],
          onSale: response["result"]["onSale"],
          sellingPrice: response["result"]["sellingPrice"],
        };
      detail["nftId"] = _id;
      detail["isPlaylistNft"] = true;
      // detail({ ...detail, ...response["result"]["musicDetails"] });
      setMusicDetail({ ...detail, ...response["result"]["playlistDetails"] });

      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const play = () => {
    if (id && history.location.pathname.includes("/app/NftDetails/")) {
      if (!nftDetail["isSubscribed"] && nftDetail["private"])
        notifier.error(t("notifier.error.toast15"));
      else dispatch(addSongAction(musicDetail));
    } else if (
      musicDetail["uploader"] &&
      !musicDetail["uploader"]["isSubscribed"] &&
      musicDetail["private"]
    )
      notifier.error(t("notifier.error.toast15"));
    else dispatch(addSongAction(musicDetail));
  };
  useEffect(() => {
    if (nftId)
      history.push(`/app/SongDetail/${nftId}?referralId=${referralId}`);
    else if (id && history.location.pathname.includes("/app/SongDetails/"))
      getMusicDetail(id);
    else if (id && history.location.pathname.includes("/app/NftDetails/"))
      getNftDetails(id);
    else if (
      id &&
      history.location.pathname.includes("/app/PlaylistNftDetails/")
    )
      getPlaylistNftDetails(id);
  }, [id]);
  useEffect(() => {}, [musicDetail]);
  const flaguser = async () => {
    try {
      setLoading(true);
      const response = await ApiService.FLAG_USER({
        message: "Reason",
        assetId: musicDetail["_id"],
        verify: musicDetail["uploader"]
          ? musicDetail["uploader"]["_id"]
          : musicDetail["owner"]["_id"],
      });
      notifier.success(t("notifier.success.toast4"));
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };
  const toggleMenu = (value, id, index) => {
    setOpen(false);
    setAlbumMenu(false);
    setSelectedAlbum(id);
    setSelectedIndex(index);

    if (value && id) makeAction(value, id);
    else if (value) makeAction(value);
  };

  const makeAction = (key, id) => {
    if (
      musicDetail["uploader"] &&
      !musicDetail["uploader"]["isSubscribed"] &&
      musicDetail["private"]
    )
      notifier.error(t("notifier.error.toast15"));
    else
      switch (key) {
        case "m3":
          setIsAlbum(false);
          setShowPlaylist(true);
          break;
        case "m4":
          setIsAlbum(true);
          setShowPlaylist(true);
          break;
      }
  };
  const handleCopy = async (action) => {
    const thumbnail = musicDetail.GIF?.filePath || musicDetail.thumbnailImg?.filePath;
    const url = await generateDynamicLink('song', musicDetail._id, musicDetail.title, '', thumbnail);
    
    switch (action) {
      case "m14":
        copyToClipboard(url);
        notifier.info(t("qrPopup.tooltip"));
        break;
      case "m15":
        onShare(action, url, {
          id: userData._id,
          referralLink: url,
          eventType: ["sharedOutbound"],
          eventAsset: musicDetail?._id,
          sharedBy: fullName(userData),
          eventValue: ["Music"],
          socialMedia: "facebook",
        });
        break;
      case "m16":
        onShare(action, url, {
          id: userData._id,
          referralLink: url,
          eventType: ["sharedOutbound"],
          eventAsset: musicDetail?._id,
          sharedBy: fullName(userData),
          eventValue: ["Music"],
          socialMedia: "twitter",
        });
        break;
      case "Share on Instagram":
        onShare(action, url);
        break;

      default:
        break;
    }
  };
  const handleClick = (event) => {
    setOption(!option);
    putRecors({
      id: userData._id,
      referralLink: window.location.href,
      eventType: ["click"],
      eventAsset: musicDetail?._id,
      sharedBy: fullName(userData),
      eventValue: ["Music"],
      socialMedia: null,
    });
  };
  const handleClose = () => {
    setOption(false);
  };
  return (
    <Box>
      <Box
        sx={{
          color: "#999999",
          display: "flex",
          alignItems: "center",
          padding: "0 20px 20px",
        }}
        className="_cp fs-14"
        onClick={() => history.goBack()}
      >
        <ArrowBackIosIcon className="fs-14" sx={{ color: "#999999" }} /> Back
      </Box>
      <Box style={{ paddingBottom: "100px", position: "relative" }}>
        <Box sx={{ position: "relative" }}>
          <Box>
            <Stack spacing={1.5} direction="row" gap="20px" padding="10px 20px">
              <img
                className="_img_medium  br16"
                src={
                  musicDetail["thumbnailImg"]
                    ? musicDetail["thumbnailImg"]["filePath"]
                    : musicDetail["GIF"]
                    ? musicDetail["GIF"]["filePath"]
                    : ""
                }
                alt="music"
              />
              <Stack direction="column" justifyContent="center" spacing={1}>
                <Typography className="fs-20">
                  {musicDetail["title"]}
                </Typography>

                <Typography className={"fs-14 fade-text-60"} align="left">
                  {musicDetail["owner"] ? fullName(musicDetail["owner"]) : ""}
                </Typography>

                <Stack
                  direction="row"
                  justifyContent="flex-start"
                  spacing={1}
                  sx={{ marginTop: "0 !important" }}
                >
                  {musicDetail["duration"] ? (
                    <HMSTag duration={musicDetail["duration"]} />
                  ) : null}
                </Stack>
                {musicDetail["fileId"] ? (
                  <Stack
                    direction="row"
                    justifyContent="flex-start"
                    alignItems="center"
                    marginTop="10px !important"
                    spacing={1}
                  >
                    <Button
                      variant="outlined"
                      onClick={() => play()}
                    >
                      {t("songDetail.text1")}
                    </Button>
                    {musicDetail["fileId"] ? (
                      <Box sx={{ position: "relative" }}>
                        <MoreVertIcon
                          className="_cp"
                          onClick={(e) => {
                            e.stopPropagation();
                            setAlbumMenu(!openAlbumMenu);
                          }}
                          color="default"
                        />

                        {openAlbumMenu ? (
                          <OutsideClickHandler
                            onOutsideClick={() => setAlbumMenu(false)}
                          >
                            <ProfileMenu
                              isMenu={open}
                              actions={[
                                {
                                  key: "m3",
                                  action: t("dropMenu.m3"),
                                },
                                isOwnerId(musicDetail?.uploader?._id)
                                  ? {
                                      key: "m4",
                                      action: t("dropMenu.m4"),
                                    }
                                  : "",
                              ]}
                              handleProfileMenuChoice={(action) =>
                                toggleMenu(action, musicDetail._id, null)
                              }
                            />
                          </OutsideClickHandler>
                        ) : null}
                      </Box>
                    ) : null}
                    <Box sx={{ position: "relative" }}>
                      <Button
                        className="__play_all "
                        onClick={handleClick}
                        sx={{
                          width: "96px",
                          height: "36px !important",
                          fontSize: "12px !important",
                          fontWeight: "400 !important",
                        }}
                        variant="outlined"
                        startIcon={
                          <IosShareIcon
                            className="__play_all_play"
                            color="default"
                          />
                        }
                      >
                        {t("nftDetail.detail.share")}
                      </Button>
                      {option ? (
                        <OutsideClickHandler
                          onOutsideClick={() => {
                            handleClose();
                          }}
                        >
                          <ProfileMenu
                            right={"0px"}
                            isHeader={true}
                            isLast={"40px"}
                            actions={[
                              { key: "m14", action: t("dropMenu.m14") },
                              { key: "m15", action: t("dropMenu.m15") },
                              { key: "m16", action: t("dropMenu.m16") },
                              // "Share on Instagram",
                            ]}
                            handleProfileMenuChoice={(key) => (
                              handleCopy(key), handleClose()
                            )}
                          />
                        </OutsideClickHandler>
                      ) : null}
                    </Box>
                  </Stack>
                ) : null}

                <Stack direction="row" spacing={2}>
                  {/* <Stack direction="row" alignItems="center" spacing={1}>
                    <VisibilityIcon color="default" />{" "}
                    <Typography className="fs-14 fw-b">
                      {t("nftDetail.detail.views")}: {musicDetail["views"]}
                    </Typography>
                  </Stack> */}
                  <Stack direction="row" alignItems="center" spacing={1}>
                    <img
                      style={{ width: "15px", height: "15px" }}
                      src={Images.listen}
                    />{" "}
                    <Typography className="fs-14 fw-b">
                      {t("analytics.card.card3")}: {musicDetail["listens"]}
                    </Typography>
                  </Stack>
                </Stack>
              </Stack>
            </Stack>
          </Box>
          <Box className="__back_cover">
            <img
              className=" mx-auto h100 w100 br-25"
              src={
                musicDetail["thumbnailImg"]
                  ? musicDetail["thumbnailImg"]["filePath"]
                  : musicDetail["GIF"]
                  ? musicDetail["GIF"]["filePath"]
                  : ""
              }
              alt="music"
            />
          </Box>
        </Box>
        <Box
          className="__main_pading w50_responsive"
          sx={{
            marginTop: "1rem",
            // background: "#1E1E1E",
            background: "#090909",
            paddingTop: "18px",
            paddingBottom: "80px",
          }}
        >
          <Stack spacing={0.2}>
            {musicDetail["nftDetails"] || musicDetail["onSale"] ? (
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                sx={{
                  padding: "10px",
                  border: "1px solid",
                  background: "#ffffff30",
                  borderRadius: "7px",
                  height: "58px",
                }}
              >
                <Stack>
                  <Typography className="fs-13 fade-text">
                    NFT Availabe
                  </Typography>
                  <Typography className="fs-17">Yes</Typography>
                </Stack>
                {musicDetail?.nftId && musicDetail.platform ? (
                  musicDetail.platform === "Hedera" ? (
                    <img
                      onClick={() =>
                        history.push(`/app/NftDetail/${musicDetail?.nftId}`)
                      }
                      title="View NFT details"
                      style={{ cursor: "pointer", width: "32px" }}
                      src={Images.hbar_2}
                      alt=""
                    />
                  ) : musicDetail?.platform === "Polygon" ? (
                    <img
                      onClick={() =>
                        history.push(`/app/NftDetail/${musicDetail?.nftId}`)
                      }
                      title="View NFT details"
                      style={{ cursor: "pointer", width: "32px" }}
                      src={Images.polygoon2}
                      alt=""
                    />
                  ) : musicDetail?.platform === "Siki" ? (
                    <img
                      onClick={() =>
                        history.push(`/app/NftDetail/${musicDetail?.nftId}`)
                      }
                      title="View NFT details"
                      style={{ cursor: "pointer", width: "32px" }}
                      src={Images.sikitoken}
                      alt=""
                    />
                  ) : (
                    <img
                      onClick={() =>
                        history.push(`/app/NftDetail/${musicDetail?.nftId}`)
                      }
                      title="View NFT details"
                      style={{ cursor: "pointer", width: "32px" }}
                      src={Images.near_nft}
                      alt=""
                    />
                  )
                ) : null}
                {!isOwner(
                  musicDetail["owner"] ? musicDetail["owner"]["email"] : ""
                ) ? (
                  index >= 0 ||
                  musicDetail["nftDetails"]["onAuction"] ||
                  musicDetail["nftDetails"]["onSale"] ||
                  musicDetail["onAuction"] ||
                  musicDetail["onSale"] ? (
                    history.location.pathname.includes(
                      "/app/PlaylistNftDetails/"
                    ) ||
                    history.location.pathname.includes("/app/NftDetails/") ? (
                      <Stack
                        className="_cp"
                        direction="row"
                        spacing={1}
                        alignItems="center"
                        onClick={() => setBuyBid(true)}
                      >
                        <Typography className="fs-15" color="primary">
                          {index >= 0 && owners.length > 0 ? "Buy" : ""}

                          {id &&
                          history.location.pathname.includes(
                            "/app/PlaylistNftDetails/"
                          )
                            ? "Buy"
                            : ""}
                        </Typography>
                        <ArrowForwardIosIcon
                          color="primary"
                          className="fs-14"
                        />
                      </Stack>
                    ) : null
                  ) : null
                ) : null}
              </Stack>
            ) : null}

            {musicDetail["nftCount"] ? (
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                sx={{
                  padding: "10px",
                  height: "58px",
                }}
              >
                <Stack>
                  <Typography className="fs-13 fade-text">
                    Number of NFTs
                  </Typography>
                  <Typography className="fs-17">
                    {musicDetail["nftCount"]}
                  </Typography>
                </Stack>
              </Stack>
            ) : null}
            {musicDetail["title"] ? (
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                sx={{
                  padding: "10px",
                  height: "58px",
                }}
              >
                <Stack>
                  <Typography className="fs-13 fade-text">
                    {musicDetail["playlistDetails"]
                      ? "Studio"
                      : t("songDetail.text2")}{" "}
                    {t("name")}
                  </Typography>
                  <Typography className="fs-17 text-capitalize">
                    {musicDetail["title"]}
                  </Typography>
                </Stack>
              </Stack>
            ) : null}
            {musicDetail["uploader"] ? (
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                sx={{
                  padding: "10px",
                  height: "58px",
                }}
              >
                <Stack>
                  <Typography className="fs-13 fade-text">
                    {t("songDetail.text3")}
                  </Typography>
                  <Stack
                    direction="row"
                    alignItems="center"
                    sx={{
                      overflowX: "scroll",
                      gap: "6px",
                      width: "245px",
                    }}
                  >
                    {musicDetail.artistData ? (
                      musicDetail.artistData.map((a, index) => (
                        <Typography
                          className="fs-17"
                          key={index}
                          style={{ whiteSpace: "nowrap" }}
                        >
                          {a?.displayArtistName}
                          {index == musicDetail.artistData.length - 1
                            ? ""
                            : ","}
                        </Typography>
                      ))
                    ) : (
                      <Typography className="fs-17">
                        {musicDetail["artist"]
                          ? musicDetail["artist"]
                          : fullName(
                              musicDetail["owner"]
                                ? musicDetail["owner"]
                                : musicDetail["uploader"]
                            )}
                      </Typography>
                    )}
                  </Stack>
                </Stack>
                {musicDetail["owner"] &&
                !isOwner(musicDetail["owner"]["email"]) ? (
                  <Stack
                    className="_cp"
                    direction="row"
                    spacing={1}
                    alignItems="center"
                    onClick={() =>
                      history.push(
                        `/app/ArtistProfile/${
                          musicDetail["owner"]
                            ? musicDetail["owner"]["_id"]
                            : musicDetail["uploader"]["_id"]
                        }`
                      )
                    }
                  >
                    <Typography className="fs-15" color="primary">
                      {t("songDetail.text4")}
                    </Typography>
                    <ArrowForwardIosIcon color="primary" className="fs-14" />
                  </Stack>
                ) : null}
              </Stack>
            ) : null}
            {musicDetail["description"] ? (
              <Stack sx={{ padding: "10px" }}>
                <Typography className="fs-13 fade-text">
                  {t("uploadMusic.input5.label")}
                </Typography>
                <Typography
                  className="fs-17"
                  sx={{
                    textAlign: "left",
                    wordBreak: "break-word",
                    lineHeight: "20px",
                  }}
                >
                  {musicDetail["description"]}
                </Typography>
              </Stack>
            ) : null}
            {musicDetail["playlistDetails"] ? null : (
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                sx={{
                  padding: "10px",
                  height: "58px",
                }}
              >
                <Stack>
                  <Typography className="fs-13 fade-text">
                    {t("addPopup.explicit")}
                  </Typography>
                  <Typography className="fs-17">
                    {musicDetail["isExplicit"] ? "Yes" : "No"}
                  </Typography>
                </Stack>
              </Stack>
            )}
            {musicDetail["playlistDetails"] && musicDetail["onAuction"] ? (
              <>
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  sx={{ padding: "10px" }}
                >
                  <Box>
                    <Typography className="fs-13 fade-text">
                      {t("songDetail.text5")}
                    </Typography>
                    <Typography className="fs-17">
                      {musicDetail["startDateString"]}
                    </Typography>
                  </Box>
                </Stack>
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  sx={{ padding: "10px" }}
                >
                  <Box>
                    <Typography className="fs-13 fade-text">
                      {t("songDetail.text6")}
                    </Typography>
                    <Typography className="fs-17">
                      {musicDetail["endDateString"]}
                    </Typography>
                  </Box>
                </Stack>
              </>
            ) : null}
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              sx={{
                padding: "10px",
                height: "58px",
              }}
            >
              {musicDetail["releaseDate"] ? (
                <Stack>
                  <Typography className="fs-13 fade-text">
                    {t("nftDetail.detail.releaseDate")}
                  </Typography>
                  <Typography className="fs-17">
                    {formatedDate(musicDetail["releaseDate"])}
                  </Typography>
                </Stack>
              ) : null}
            </Stack>
            {musicDetail["ISRCCode"] ? (
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                sx={{
                  padding: "10px",
                  height: "58px",
                }}
              >
                <Stack>
                  <Typography className="fs-13 fade-text">
                    {t("songDetail.text7")}
                  </Typography>
                  <Typography className="fs-17">
                    {musicDetail["ISRCCode"]
                      ? musicDetail["ISRCCode"]
                      : t("noData.noData")}
                  </Typography>
                </Stack>
              </Stack>
            ) : null}

            {musicDetail["collaborators"] &&
            musicDetail["collaborators"].length > 0 ? (
              <Stack
                sx={{
                  padding: "10px",
                }}
              >
                <Box>
                  <Typography className="fs-13 fade-text">
                    {t("uploadMusic.input10.label1")}
                  </Typography>
                  {musicDetail["collaborators"].map((c, index) => (
                    <Stack
                      key={index}
                      direction="row"
                      justifyContent="space-between"
                    >
                      <Typography className="fs-15">{c["role"]}</Typography>
                      <Typography className="fs-17">
                        {fullName(c["_id"])}
                      </Typography>
                    </Stack>
                  ))}
                </Box>
              </Stack>
            ) : null}

            {musicDetail["royalties"] && musicDetail["royalties"].length > 0 ? (
              <Stack sx={{ padding: "10px" }}>
                <Typography className="fs-13 fade-text">
                  {t("songDetail.text8")}
                </Typography>
                <Stack spacing={1}>
                  {musicDetail["royalties"].map((r, index) => (
                    <Stack
                      key={index}
                      direction="row"
                      justifyContent="space-between"
                    >
                      <Typography className="fs-15 ">
                        {r["percentage"]}%
                      </Typography>
                      <Stack
                        direction="row"
                        justifyContent="space-between"
                        spacing={1}
                      >
                        <Typography className="fs-13 canceled">
                          {isOwner(r["_id"]["email"])}
                        </Typography>
                        <Typography className="fs-17">
                          {fullName(r["_id"])}
                        </Typography>
                      </Stack>
                    </Stack>
                  ))}
                </Stack>
              </Stack>
            ) : null}
            {musicDetail["ownerRoyalty"] ? (
              <Stack sx={{ padding: "10px" }} direction="column">
                <Typography className="fs-13 fade-text">
                  {t("songDetail.text9")}
                </Typography>
                <Stack
                  direction="row"
                  alignItems="center"
                  justifyContent="space-between"
                >
                  <Typography className="fs-15">
                    {musicDetail["ownerRoyalty"]
                      ? musicDetail["ownerRoyalty"]
                      : 0}
                    %
                  </Typography>
                  <Typography className="fs-15">
                    {fullName(
                      musicDetail["uploader"] ? musicDetail["uploader"] : ""
                    )}
                  </Typography>
                </Stack>
              </Stack>
            ) : null}

            {(musicDetail["owner"] || musicDetail["uploader"]) &&
            !isOwnerId(
              musicDetail["owner"]
                ? musicDetail["owner"]["_id"]
                : musicDetail["uploader"] && musicDetail["uploader"]["_id"]
                ? musicDetail["uploader"]["_id"]
                : typeof musicDetail["uploader"] === "string"
                ? musicDetail["uploader"]
                : ""
            ) &&
            musicDetail.nftId ? (
              <Stack>
                <TipContainer
                  isArtist={true}
                  artistName={fullName(
                    musicDetail["owner"]
                      ? musicDetail["owner"]
                      : musicDetail["uploader"]
                      ? musicDetail["uploader"]
                      : ""
                  )}
                  id={
                    musicDetail["owner"]
                      ? musicDetail["owner"]["_id"]
                      : musicDetail["uploader"]
                      ? musicDetail["uploader"]["_id"]
                      : ""
                  }
                />
              </Stack>
            ) : null}
            {(musicDetail["owner"] || musicDetail["uploader"]) &&
            !isOwnerId(
              musicDetail["owner"]
                ? musicDetail["owner"]["_id"]
                : musicDetail["uploader"]
                ? musicDetail["uploader"]["_id"]
                : ""
            ) &&
            !musicDetail["isPlaylistNft"] ? (
              <Stack
                sx={{ marginTop: "10px !important" }}
                className="p-10"
                spacing={1}
              >
                <Stack spacing={1} direction="row" alignItems="center">
                  <img src={Images.flag} alt="flag" />
                  <Typography className="fs-13 fade-text">
                    {t("flag") + " " + t("home.tabs.music.tab")}
                  </Typography>
                </Stack>
                <Stack spacing={1} alignItems="flex-start">
                  <Typography className="fs-15 fade-text">
                    {t("flagMsg")}
                  </Typography>
                  <Button
                    variant="outlined"
                    className="fs-15"
                    onClick={() => flaguser()}
                  >
                    {t("flag")}
                  </Button>
                </Stack>
              </Stack>
            ) : null}
          </Stack>
        </Box>
        {buyBid ? (
          <Box className="__buy_bid_info" sx={{ borderRadius: "6px" }}>
            <BuyBidInfo
              id={
                musicDetail["nftId"] ? musicDetail["nftId"] : musicDetail["_id"]
              }
              isPlaylistNft={musicDetail["isPlaylistNft"]}
              handleBack={() => setBuyBid(false)}
            />
          </Box>
        ) : null}
        {loading ? <Loader /> : null}
      </Box>
      {showPlaylist ? (
        <AddMusicToPlaylist
          musicId={musicDetail["_id"]}
          isAlbum={isAlbum}
          open={showPlaylist}
          handleClose={() => setShowPlaylist(false)}
        />
      ) : null}
    </Box>
  );
}
